<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="800px">
    <div>
      <div style="margin-bottom: 40px;">
      </div>
      <div>
        <el-table 
          :data="pageData.list"
          :default-sort = "{}"
          border
          style="width: 100%"
          height="400px"
          v-if="title == '选择借款单'">
          <el-table-column prop="business_no" label="借款单流水号"></el-table-column>
          <el-table-column prop="dept_name" label="借款部门"></el-table-column>
          <el-table-column prop="user_name" width="80" label="借款员工"></el-table-column>
          <el-table-column prop="available_amount" width="100" label="可报销金额"></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="confirmFun(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-table 
          :data="pageData.listYFD"
          :default-sort = "{}"
          border
          style="width: 100%"
          height="400px"
          v-if="title == '选择预付单'">
          <el-table-column prop="business_no" label="预付单流水号"></el-table-column>
          <el-table-column prop="dept_name" label="预付部门"></el-table-column>
          <el-table-column prop="pay_bank_user" label="付款单位"></el-table-column>
          <el-table-column prop="amount" width="100" label="预付金额"></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="confirmFun(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="personnel-footer">
      <el-button size="mini" type="info" @click="closeFun">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Http from "../common/Http";
export default {
  name: "SelectJKD",
  components:{},
  data(){
    return {
      dialogVisible:false,
      loading:false,
      where:{
        keyword:'',
        project_id:0,
        project_name:'',
      },
      pageData:{
        list:[],
        listYFD:[],
      },
      callback_fun:undefined,
      title:"选择借款单",
    }
  },
  mounted() {
  },
  methods:{
    initConfig(){
      this.where = {
        keyword:'',
        project_id:0,
        project_name:'',
      }
      this.pageData = {
        list:[],
        listYFD:[],
      };
      this.callback_fun=undefined;
    },
    show(config,callback_fun){
      const that = this;
      that.initConfig();
      that.where = config;

      that.dialogVisible=true;
      if(typeof callback_fun === "function"){
        that.callback_fun = callback_fun;
      }
      // 判断类型 1: 借款单 2：预付单
      if(that.where.type == 2) {
        that.pageData.list = [];
        that.pageData.listYFD = [];
        that.title = "选择预付单";
        that.getYFDList();
      } else {
        that.pageData.list = [];
        that.pageData.listYFD = [];
        that.title = "选择借款单";
        that.getList(that.where.is_old);
      }
      
    },
    confirmFun(item){
      if(typeof this.callback_fun === "function"){
        this.callback_fun(item);
        this.callback_fun = undefined;
      }
      this.dialogVisible=false;
    },
    closeFun(){
      if(typeof this.callback_fun ==="function"){
        this.callback_fun=undefined;
      }
      this.dialogVisible=false;
    },
    getList(is_old) {
      const that = this;
      that.loading=true;
      let params = that.where;
      params.page_size = 10000
      let url = "https://budget.gdzawy.com:9000/sharingPlatform/LoanVoucher/getList"
      if (is_old == 1) {
        url = "https://budget.gdzawy.com:9000/sharingPlatform/LoanHistoryVoucher/getList"
      }
      Http.get(url,params,res=>{
        console.log(res)
        if(res.code == 0) {
          that.pageData.list = res.data.data
        }
        that.loading=false;
      })
    },
    getYFDList() {
      const that = this;
      that.loading=true;
      let params = that.where;
      params.page_size = 10000
      Http.get("https://budget.gdzawy.com:9001/sharingPlatform/PrepayOrder/getAllList",params,res=>{
        console.log(res)
        if(res.code == 0) {
          that.pageData.listYFD = res.data
          console.log(that.pageData.listYFD);
        }
        that.loading=false;
      })
    },
    searchs() {
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../common";
.personnel-footer{
  margin-top: 10px;
  width: 100%;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/Flow/components/SelectJKD.vue